/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { isFirefox, isMobile } from 'react-device-detect';
import { PdfInIframe } from './PdfIframe';
import { PdfViewer } from './PdfViewer';

export type PdfPresenterExtendProps = {
	title?: string;
	src?: string;
};

export type PdfPresenterProps = {
	title?: string;
	srcSet: {
		primary?: string;
		secondary?: string;
	};
};

export const PdfPresenter = ({ srcSet, ...props }: PdfPresenterProps) => {
	return (
		<div
			className="flex flex-column w-full h-full gap-2 p-2 bg-gray-100 overflow-scroll"
			style={{ minHeight: 500 }}
		>
			{isMobile ? (
				<>
					{isFirefox ? (
						<PdfInIframe {...props} src={srcSet?.secondary} />
					) : (
						<PdfViewer {...props} src={srcSet.secondary} />
					)}
				</>
			) : (
				<PdfInIframe {...props} src={srcSet?.primary} />
			)}
		</div>
	);
};
